/* =====================================================
   MIRIAM FASOLATO — Scroll 3D & Modern Visual Effects
   ===================================================== */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isMobile = window.matchMedia('(max-width: 768px)').matches;

  /* ── 1. SMOOTH PAGE LOAD ANIMATION ───────────────────── */
  function setupPageLoad() {
    document.body.classList.add('is-loading');

    function reveal() {
      document.body.classList.remove('is-loading');
      document.body.classList.add('is-loaded');

      if (reduced) return;

      /* Stagger hero elements */
      var heroElements = document.querySelectorAll(
        '.hero-label, .hero-title, .hero-text, .hero-buttons, .hero-visual'
      );
      heroElements.forEach(function (el, i) {
        el.classList.add('hero-stagger');
        setTimeout(function () {
          el.classList.add('revealed');
        }, 150 + i * 80);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', reveal);
    } else {
      reveal();
    }
  }

  /* ── 2. SCROLL PROGRESS BAR ──────────────────────────── */
  var bar = document.createElement('div');
  bar.id = 'scroll-progress-bar';
  document.body.prepend(bar);

  /* ── 3. PARALLAX (hero) — with lerp for smooth motion ── */
  function setupParallax() {
    if (reduced) return;
    var heroImg   = document.querySelector('.hero-image-wrapper');
    var circle1   = document.querySelector('.hero-circle-1');
    var circle2   = document.querySelector('.hero-circle-2');
    var heroLabel = document.querySelector('.hero-label');
    var heroText  = document.querySelector('.hero-text');

    /* Lerp targets & current values */
    var targets = { img: 0, c1: 0, c1s: 1, c2: 0, label: 0, text: 0 };
    var current = { img: 0, c1: 0, c1s: 1, c2: 0, label: 0, text: 0 };
    var lerpFactor = 0.08;
    var running = true;

    function lerp(a, b, t) {
      return a + (b - a) * t;
    }

    function updateTargets() {
      var s = window.scrollY;
      var docH = document.documentElement.scrollHeight - window.innerHeight;
      bar.style.width = (docH > 0 ? (s / docH) * 100 : 0) + '%';

      targets.img   = s * 0.25;
      targets.c1    = s * -0.18;
      targets.c1s   = 1 + s * 0.0003;
      targets.c2    = s * 0.12;
      targets.label = s * 0.08;
      targets.text  = s * 0.05;
    }

    function animate() {
      if (!running) return;

      current.img   = lerp(current.img,   targets.img,   lerpFactor);
      current.c1    = lerp(current.c1,    targets.c1,    lerpFactor);
      current.c1s   = lerp(current.c1s,   targets.c1s,   lerpFactor);
      current.c2    = lerp(current.c2,    targets.c2,    lerpFactor);
      current.label = lerp(current.label, targets.label, lerpFactor);
      current.text  = lerp(current.text,  targets.text,  lerpFactor);

      if (heroImg)   heroImg.style.transform   = 'translateY(' + current.img + 'px)';
      if (circle1)   circle1.style.transform   = 'translateY(' + current.c1 + 'px) scale(' + current.c1s + ')';
      if (circle2)   circle2.style.transform   = 'translateY(' + current.c2 + 'px)';
      if (heroLabel) heroLabel.style.transform  = 'translateY(' + current.label + 'px)';
      if (heroText)  heroText.style.transform   = 'translateY(' + current.text + 'px)';

      requestAnimationFrame(animate);
    }

    window.addEventListener('scroll', updateTargets, { passive: true });
    updateTargets();
    animate();

    /* Stop loop when page hidden */
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        running = false;
      } else {
        running = true;
        animate();
      }
    });
  }

  /* ── 4. MOUSE-TRACKING 3D TILT ──────────────────────── */
  function setupTilt() {
    if (reduced || isMobile) return;

    var selectors = [
      '.product-card',
      '.category-card',
      '.gallery-item',
      '.story-image',
      '.story-visual'
    ];

    var cards = document.querySelectorAll(selectors.join(','));

    cards.forEach(function (card) {
      var inner = card.querySelector('img, .category-art, .product-image, .glass-art-wrap');

      card.addEventListener('mouseenter', function () {
        card.style.transition = 'transform 0.15s ease, box-shadow 0.3s ease';
      });

      card.addEventListener('mousemove', function (e) {
        var r   = card.getBoundingClientRect();
        var x   = e.clientX - r.left;
        var y   = e.clientY - r.top;
        var cx  = r.width  / 2;
        var cy  = r.height / 2;
        var rx  = ((y - cy) / cy) * -8;
        var ry  = ((x - cx) / cx) *  8;

        card.style.transform = 'perspective(900px) rotateX(' + rx + 'deg) rotateY(' + ry + 'deg) translateZ(12px)';
        card.style.boxShadow =
          (ry * -2) + 'px ' + (rx * 2) + 'px 40px rgba(58,53,48,0.14),' +
          '0 20px 50px rgba(58,53,48,0.09)';

        /* subtle shine overlay */
        var shine = card.querySelector('.tilt-shine');
        if (!shine) {
          shine = document.createElement('div');
          shine.className = 'tilt-shine';
          card.style.position = 'relative';
          card.appendChild(shine);
        }
        shine.style.background =
          'radial-gradient(circle at ' + (x / r.width * 100) + '% ' + (y / r.height * 100) + '%, ' +
          'rgba(196,168,124,0.12) 0%, transparent 70%)';

        if (inner) inner.style.transform = 'translateZ(6px)';
      });

      card.addEventListener('mouseleave', function () {
        card.style.transition = 'transform 0.7s cubic-bezier(0.23,1,0.32,1), box-shadow 0.7s ease';
        card.style.transform  = 'perspective(900px) rotateX(0deg) rotateY(0deg) translateZ(0)';
        card.style.boxShadow  = '';
        if (inner) inner.style.transform = '';
        var shine = card.querySelector('.tilt-shine');
        if (shine) shine.style.background = 'none';
      });
    });
  }

  /* ── 5. STAGGER REVEAL (grids) ──────────────────────── */
  function setupStagger() {
    if (!('IntersectionObserver' in window)) return;

    var grids = document.querySelectorAll(
      '.categories-grid, .products-grid, .gallery-grid'
    );

    grids.forEach(function (grid) {
      var kids = Array.from(grid.children);
      if (!kids.length) return;

      kids.forEach(function (kid, i) {
        kid.style.opacity   = '0';
        kid.style.transform = 'translateY(50px) scale(0.96)';
        kid.style.transition =
          'opacity 0.65s ease ' + (i * 0.09) + 's,' +
          'transform 0.65s cubic-bezier(0.23,1,0.32,1) ' + (i * 0.09) + 's';
      });

      new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          Array.from(e.target.children).forEach(function (kid) {
            kid.style.opacity   = '1';
            kid.style.transform = 'translateY(0) scale(1)';
          });
          obs.unobserve(e.target);
        });
      }, { threshold: 0.08 }).observe(grid);
    });
  }

  /* ── 6. SECTION DEPTH REVEAL + SPLIT REVEAL ──────────── */
  function setupSectionDepth() {
    if (reduced || !('IntersectionObserver' in window)) return;

    var sections = document.querySelectorAll('.animate-section');
    var revealIndex = 0;

    sections.forEach(function (sec) {
      /* Alternate split-reveal direction for non-grid sections */
      var hasGrid = sec.querySelector('.categories-grid, .products-grid, .gallery-grid');
      if (!hasGrid && !isMobile) {
        var dir = revealIndex % 2 === 0 ? 'reveal-left' : 'reveal-right';
        sec.classList.add(dir);
        revealIndex++;
      } else if (!sec.classList.contains('reveal-left') && !sec.classList.contains('reveal-right')) {
        /* Default 3D reveal for grid sections */
        sec.style.opacity   = '0';
        sec.style.transform = 'perspective(1000px) translateY(60px) rotateX(4deg)';
        sec.style.transition = 'opacity 0.9s ease, transform 0.9s cubic-bezier(0.23,1,0.32,1)';
        sec.style.transformOrigin = 'center top';
      }

      new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          if (e.target.classList.contains('reveal-left') || e.target.classList.contains('reveal-right')) {
            e.target.classList.add('visible');
          } else {
            e.target.style.opacity   = '1';
            e.target.style.transform = 'perspective(1000px) translateY(0) rotateX(0deg)';
          }
          e.target.classList.add('visible');
          obs.unobserve(e.target);
        });
      }, { threshold: 0.07 }).observe(sec);
    });
  }

  /* ── 7. SECTION TITLE WORD REVEAL ───────────────────── */
  function setupTitleReveal() {
    if (reduced || !('IntersectionObserver' in window)) return;

    document.querySelectorAll('.section-title').forEach(function (el) {
      var html = el.innerHTML;
      el.innerHTML = html.replace(/(<[^>]+>)|(\S+)/g, function (match, tag, word) {
        if (tag)  return tag;
        if (word) return '<span class="wr"><span class="wi">' + word + '</span></span>';
        return match;
      });

      var words = el.querySelectorAll('.wi');
      words.forEach(function (w, i) {
        w.style.cssText = 'display:inline-block;transform:translateY(110%);opacity:0;' +
          'transition:transform 0.65s cubic-bezier(0.23,1,0.32,1) ' + (i * 0.07) + 's,' +
          'opacity 0.5s ease ' + (i * 0.07) + 's;';
      });

      new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          e.target.querySelectorAll('.wi').forEach(function (w) {
            w.style.transform = 'translateY(0)';
            w.style.opacity   = '1';
          });
          obs.unobserve(e.target);
        });
      }, { threshold: 0.5 }).observe(el);
    });
  }

  /* ── 8. HERO FLOATING PARTICLES ─────────────────────── */
  function setupParticles() {
    if (reduced) return;
    var hero = document.querySelector('.hero');
    if (!hero) return;

    var sizes   = [3, 4, 5, 6, 4, 5];
    var delays  = [0, 1.5, 3, 4.5, 6, 2.2];
    var durations = [9, 11, 8, 12, 10, 7];

    sizes.forEach(function (s, i) {
      var p = document.createElement('div');
      p.className = 'hero-particle';
      p.style.cssText =
        'position:absolute;border-radius:50%;pointer-events:none;z-index:0;' +
        'width:' + s + 'px;height:' + s + 'px;' +
        'left:' + (8 + i * 15 + Math.random() * 5) + '%;' +
        'top:'  + (15 + Math.random() * 65) + '%;' +
        'background:radial-gradient(circle,rgba(196,168,124,0.55),rgba(196,168,124,0.1));' +
        'animation:particleFloat ' + durations[i] + 's ease-in-out ' + delays[i] + 's infinite;';
      hero.appendChild(p);
    });
  }

  /* ── 9. GOLD SHIMMER ON GOLD ELEMENTS ───────────────── */
  function setupShimmer() {
    if (reduced) return;
    document.querySelectorAll('.hero-label, .section-label').forEach(function (el) {
      el.classList.add('gold-shimmer');
    });
  }

  /* ── 10. MAGNETIC BUTTONS ───────────────────────────── */
  function setupMagneticBtns() {
    if (reduced || isMobile) return;
    document.querySelectorAll('.btn-primary, .btn-outline').forEach(function (btn) {
      btn.addEventListener('mousemove', function (e) {
        var r  = btn.getBoundingClientRect();
        var dx = (e.clientX - r.left - r.width  / 2) * 0.25;
        var dy = (e.clientY - r.top  - r.height / 2) * 0.25;
        btn.style.transform = 'translate(' + dx + 'px,' + dy + 'px) translateY(-2px)';
      });
      btn.addEventListener('mouseleave', function () {
        btn.style.transform = '';
      });
    });
  }

  /* ── 11. BUTTON RIPPLE EFFECT ──────────────────────── */
  function setupRipple() {
    if (reduced) return;

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.btn-primary, .btn-outline, .btn-add-cart');
      if (!btn) return;

      var rect = btn.getBoundingClientRect();
      var ripple = document.createElement('span');
      ripple.className = 'btn-ripple';
      var size = Math.max(rect.width, rect.height);
      ripple.style.width = ripple.style.height = size + 'px';
      ripple.style.left = (e.clientX - rect.left - size / 2) + 'px';
      ripple.style.top = (e.clientY - rect.top - size / 2) + 'px';
      btn.appendChild(ripple);

      ripple.addEventListener('animationend', function () {
        ripple.remove();
      });
    });
  }

  /* ── 12. COUNTER ANIMATION ─────────────────────────── */
  function setupCounters() {
    if (!('IntersectionObserver' in window)) return;

    var counterEls = document.querySelectorAll('[data-count-to]');
    if (!counterEls.length) return;

    counterEls.forEach(function (el) {
      var target = parseInt(el.getAttribute('data-count-to'), 10);
      if (isNaN(target)) return;

      el.classList.add('counter-animate');

      new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          animateCounter(e.target, target);
          obs.unobserve(e.target);
        });
      }, { threshold: 0.5 }).observe(el);
    });

    function animateCounter(el, target) {
      var duration = 2000;
      var start = 0;
      var startTime = null;

      function step(timestamp) {
        if (!startTime) startTime = timestamp;
        var progress = Math.min((timestamp - startTime) / duration, 1);
        /* Ease out quart */
        var eased = 1 - Math.pow(1 - progress, 4);
        el.textContent = Math.floor(eased * (target - start) + start);
        if (progress < 1) {
          requestAnimationFrame(step);
        } else {
          el.textContent = target;
        }
      }
      requestAnimationFrame(step);
    }
  }

  /* ── 13. CUSTOM CURSOR (desktop only) ──────────────── */
  function setupCustomCursor() {
    if (reduced || isMobile || 'ontouchstart' in window) return;

    var cursor = document.createElement('div');
    cursor.className = 'custom-cursor';
    document.body.appendChild(cursor);

    var cx = 0, cy = 0, tx = 0, ty = 0;
    var visible = false;

    document.addEventListener('mousemove', function (e) {
      tx = e.clientX;
      ty = e.clientY;
      if (!visible) {
        visible = true;
        cursor.classList.add('visible');
      }
    });

    document.addEventListener('mouseleave', function () {
      visible = false;
      cursor.classList.remove('visible');
    });

    /* Hover detection */
    document.addEventListener('mouseover', function (e) {
      if (e.target.closest('a, button, .product-card, .category-card, .gallery-item, [role="button"], input, textarea, select')) {
        cursor.classList.add('hovering');
      }
    });

    document.addEventListener('mouseout', function (e) {
      if (e.target.closest('a, button, .product-card, .category-card, .gallery-item, [role="button"], input, textarea, select')) {
        cursor.classList.remove('hovering');
      }
    });

    function animateCursor() {
      cx += (tx - cx) * 0.15;
      cy += (ty - cy) * 0.15;
      cursor.style.left = cx + 'px';
      cursor.style.top  = cy + 'px';
      requestAnimationFrame(animateCursor);
    }
    animateCursor();
  }

  /* ── 14. SCROLL TEXT HIGHLIGHT ─────────────────────── */
  function setupTextHighlight() {
    if (reduced || !('IntersectionObserver' in window)) return;

    /* Target keywords in story sections */
    var storyTexts = document.querySelectorAll('.story-text, .story-quote');
    var keywords = ['tradizione', 'tradition', 'Murano', 'vetro', 'luce', 'Glas', 'Licht', 'Handwerk', 'artigianale', 'glass', 'light', 'craft', 'eleganza', 'elegance', 'heritage', '1300'];

    storyTexts.forEach(function (textEl) {
      var html = textEl.innerHTML;
      keywords.forEach(function (kw) {
        var regex = new RegExp('\\b(' + kw + ')\\b', 'gi');
        html = html.replace(regex, '<span class="text-highlight-word">$1</span>');
      });
      textEl.innerHTML = html;
    });

    var highlightWords = document.querySelectorAll('.text-highlight-word');
    if (!highlightWords.length) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('highlighted');
          observer.unobserve(e.target);
        }
      });
    }, { threshold: 0.8 });

    highlightWords.forEach(function (w) { observer.observe(w); });
  }

  /* ── 15. TESTIMONIAL IMPROVEMENTS ──────────────────── */
  function setupTestimonialEnhancements() {
    /* Add quote rotation on slide change */
    var dots = document.querySelectorAll('.testimonial-dot');
    if (!dots.length) return;

    /* Watch for active class changes on dots to trigger quote rotation */
    var slider = document.querySelector('.testimonials-slider');
    if (!slider) return;

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.type === 'attributes' && m.attributeName === 'class') {
          var target = m.target;
          if (target.classList.contains('active') && target.classList.contains('testimonial-item')) {
            /* Trigger quote icon rotation */
            var icon = target.querySelector('.testimonial-quote-icon svg');
            if (icon) {
              icon.style.transform = 'rotate(-10deg)';
              setTimeout(function () {
                icon.style.transform = 'rotate(0deg)';
              }, 50);
            }
          }
        }
      });
    });

    observer.observe(slider, {
      attributes: true,
      subtree: true,
      attributeFilter: ['class']
    });

    /* Reset dot progress animation on change */
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        dots.forEach(function (d) {
          /* Force restart animation by removing and re-adding class */
          d.classList.remove('active');
        });
      });
    });
  }

  /* ── 16. HERO 3D PERSPECTIVE ZOOM ON SCROLL ─────────── */
  function setupHero3DScroll() {
    if (reduced || isMobile) return;
    var heroImg = document.querySelector('.hero-image-wrapper');
    var heroTitle = document.querySelector('.hero-title');
    var circle1 = document.querySelector('.hero-circle-1');
    var circle2 = document.querySelector('.hero-circle-2');
    if (!heroImg && !heroTitle) return;

    var heroTargets = { scale: 1.1, titleZ: 30, c1rx: 0, c1ry: 0, c2rx: 0, c2ry: 0 };
    var heroCurrent = { scale: 1.1, titleZ: 30, c1rx: 0, c1ry: 0, c2rx: 0, c2ry: 0 };

    function updateHero3D() {
      var s = window.scrollY;
      var heroH = window.innerHeight;
      var progress = Math.min(s / heroH, 1);

      heroTargets.scale = 1.1 - progress * 0.1;
      heroTargets.titleZ = 30 - progress * 30;
      heroTargets.c1rx = progress * 15;
      heroTargets.c1ry = progress * -10;
      heroTargets.c2rx = progress * -8;
      heroTargets.c2ry = progress * 12;
    }

    var hero3dRunning = true;
    function animateHero3D() {
      if (!hero3dRunning) return;
      var t = 0.06;
      heroCurrent.scale = heroCurrent.scale + (heroTargets.scale - heroCurrent.scale) * t;
      heroCurrent.titleZ = heroCurrent.titleZ + (heroTargets.titleZ - heroCurrent.titleZ) * t;
      heroCurrent.c1rx = heroCurrent.c1rx + (heroTargets.c1rx - heroCurrent.c1rx) * t;
      heroCurrent.c1ry = heroCurrent.c1ry + (heroTargets.c1ry - heroCurrent.c1ry) * t;
      heroCurrent.c2rx = heroCurrent.c2rx + (heroTargets.c2rx - heroCurrent.c2rx) * t;
      heroCurrent.c2ry = heroCurrent.c2ry + (heroTargets.c2ry - heroCurrent.c2ry) * t;

      if (heroImg) {
        heroImg.style.transform = 'scale(' + heroCurrent.scale.toFixed(4) + ')';
      }
      if (heroTitle) {
        heroTitle.style.transform = 'translateZ(' + heroCurrent.titleZ.toFixed(1) + 'px)';
      }
      if (circle1) {
        circle1.style.transform += ' rotateX(' + heroCurrent.c1rx.toFixed(1) + 'deg) rotateY(' + heroCurrent.c1ry.toFixed(1) + 'deg)';
      }
      if (circle2) {
        circle2.style.transform += ' rotateX(' + heroCurrent.c2rx.toFixed(1) + 'deg) rotateY(' + heroCurrent.c2ry.toFixed(1) + 'deg)';
      }

      requestAnimationFrame(animateHero3D);
    }

    window.addEventListener('scroll', updateHero3D, { passive: true });
    updateHero3D();
    animateHero3D();

    document.addEventListener('visibilitychange', function () {
      hero3dRunning = !document.hidden;
      if (hero3dRunning) animateHero3D();
    });
  }

  /* ── 17. 3D DEPTH LAYERS (Story Section) ──────────── */
  function setupDepthLayers() {
    if (reduced || isMobile) return;
    var storySection = document.querySelector('.story-section, .lp-story');
    if (!storySection) return;

    var storyImg = storySection.querySelector('.story-image, .story-visual, .lp-story__image');
    var storyText = storySection.querySelector('.story-text, .story-content, .lp-story__text');
    if (!storyImg && !storyText) return;

    function updateDepth() {
      var rect = storySection.getBoundingClientRect();
      var viewH = window.innerHeight;
      var center = rect.top + rect.height / 2;
      var progress = (center - viewH / 2) / viewH; /* -0.5 to 0.5 */
      progress = Math.max(-0.5, Math.min(0.5, progress));

      var imgZ = progress * -40;
      var textZ = progress * 40;

      if (storyImg) storyImg.style.transform = 'translateZ(' + imgZ.toFixed(1) + 'px)';
      if (storyText) storyText.style.transform = 'translateZ(' + textZ.toFixed(1) + 'px)';
    }

    window.addEventListener('scroll', updateDepth, { passive: true });
    updateDepth();
  }

  /* ── 18. 3D FLOATING GEOMETRIC SHAPES ─────────────── */
  function setupFloatingShapes() {
    if (reduced || isMobile) return;

    var containers = document.querySelectorAll('.story-section, .lp-story, .gallery-section, .lp-gallery');
    if (!containers.length) return;

    var shapes = [];
    var shapeConfigs = [
      { type: 'circle', size: 60, top: '15%', left: '5%', opacity: 0.08 },
      { type: 'rhombus', size: 30, top: '70%', left: '90%', opacity: 0.06 },
      { type: 'line', size: 100, top: '45%', left: '2%', opacity: 0.1 },
      { type: 'circle', size: 40, top: '80%', left: '15%', opacity: 0.05 },
      { type: 'rhombus', size: 22, top: '25%', left: '85%', opacity: 0.07 }
    ];

    containers.forEach(function (container) {
      container.style.position = container.style.position || 'relative';
      container.style.overflow = 'hidden';

      shapeConfigs.forEach(function (cfg, i) {
        var el = document.createElement('div');
        el.className = 'floating-shape floating-shape--' + cfg.type;
        el.style.cssText =
          'width:' + cfg.size + 'px;height:' + (cfg.type === 'line' ? '1' : cfg.size) + 'px;' +
          'top:' + cfg.top + ';left:' + cfg.left + ';' +
          'opacity:' + cfg.opacity + ';' +
          'animation: floatShape3D ' + (8 + i * 2) + 's ease-in-out ' + (i * 0.8) + 's infinite;';
        container.appendChild(el);
        shapes.push({ el: el, container: container, baseOpacity: cfg.opacity });
      });
    });

    /* Fade shapes in when container is visible */
    if ('IntersectionObserver' in window) {
      var shapeObs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var containerShapes = e.target.querySelectorAll('.floating-shape');
          containerShapes.forEach(function (s) {
            if (e.isIntersecting) s.classList.add('visible');
          });
        });
      }, { threshold: 0.1 });
      containers.forEach(function (c) { shapeObs.observe(c); });
    }
  }

  /* ── 19. SECTION SPEED PARALLAX ───────────────────── */
  function setupSectionParallax() {
    if (reduced || isMobile) return;
    var sections = document.querySelectorAll('.animate-section');
    if (!sections.length) return;

    function updateSectionParallax() {
      var scrollY = window.scrollY;
      sections.forEach(function (sec, i) {
        var rect = sec.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > window.innerHeight) return;

        var factor = (i % 2 === 0) ? 0.95 : 1.02;
        var offset = (scrollY - sec.offsetTop) * (1 - factor);
        sec.style.transform = 'translateY(' + offset.toFixed(1) + 'px)';
      });
    }

    window.addEventListener('scroll', updateSectionParallax, { passive: true });
  }

  /* ── 20. SCROLL OPACITY FADE ──────────────────────── */
  function setupOpacityFade() {
    if (reduced) return;
    var sections = document.querySelectorAll('.animate-section');
    if (!sections.length) return;

    sections.forEach(function (s) { s.classList.add('section-opacity-fade'); });

    function updateOpacity() {
      var vh = window.innerHeight;
      sections.forEach(function (sec) {
        var rect = sec.getBoundingClientRect();
        var center = rect.top + rect.height / 2;

        /* Full opacity when centered, fade when leaving */
        var distFromCenter = Math.abs(center - vh / 2);
        var maxDist = vh * 0.8;
        var opacity = 1 - Math.max(0, (distFromCenter - vh * 0.3)) / maxDist;
        opacity = Math.max(0.3, Math.min(1, opacity));

        sec.style.opacity = opacity.toFixed(2);
      });
    }

    window.addEventListener('scroll', updateOpacity, { passive: true });
    updateOpacity();
  }

  /* ── 21. EVENT ITEMS STAGGER-SLIDE ────────────────── */
  function setupEventStagger() {
    if (reduced || !('IntersectionObserver' in window)) return;
    var eventsSection = document.querySelector('.events-section, .lp-events');
    if (!eventsSection) return;

    var items = eventsSection.querySelectorAll('.event-item, .lp-events__item');
    if (!items.length) return;

    items.forEach(function (item) {
      item.classList.add('event-item-3d');
    });

    new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var eventItems = e.target.querySelectorAll('.event-item-3d');
        eventItems.forEach(function (item, i) {
          setTimeout(function () {
            item.classList.add('revealed');
          }, i * 120);
        });
        obs.unobserve(e.target);
      });
    }, { threshold: 0.1 }).observe(eventsSection);
  }

  /* ── 22. GALLERY MASONRY DROP ─────────────────────── */
  function setupGalleryDrop() {
    if (reduced || !('IntersectionObserver' in window)) return;
    var galleryGrid = document.querySelector('.gallery-grid, .lp-gallery__grid');
    if (!galleryGrid) return;

    var items = Array.from(galleryGrid.children);
    var directions = ['drop-top', 'drop-left', 'drop-right'];

    items.forEach(function (item) {
      item.classList.add('gallery-item-drop');
    });

    new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var kids = Array.from(e.target.querySelectorAll('.gallery-item-drop'));
        kids.forEach(function (kid, i) {
          var dir = directions[i % 3];
          setTimeout(function () {
            kid.classList.add(dir);
          }, i * 100);
        });
        obs.unobserve(e.target);
      });
    }, { threshold: 0.08 }).observe(galleryGrid);
  }

  /* ── 23. FOOTER RISE-UP 3D ───────────────────────── */
  function setupFooterReveal() {
    if (reduced || !('IntersectionObserver' in window)) return;
    var footer = document.querySelector('.site-footer');
    if (!footer) return;

    /* Footer columns */
    var cols = footer.querySelectorAll('.footer-col, .footer-grid > *, .footer-column');
    cols.forEach(function (col) {
      col.classList.add('footer-col-rise');
    });

    /* Footer gold line */
    var goldLine = footer.querySelector('.footer-goldline, .site-footer::before');
    var beforeEl = footer.querySelector('hr, .footer-divider');
    if (beforeEl) {
      beforeEl.classList.add('footer-goldline-grow');
    }

    new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;

        var riseCols = e.target.querySelectorAll('.footer-col-rise');
        riseCols.forEach(function (col, i) {
          setTimeout(function () {
            col.classList.add('revealed');
          }, i * 150);
        });

        var growLine = e.target.querySelector('.footer-goldline-grow');
        if (growLine) {
          setTimeout(function () {
            growLine.classList.add('revealed');
          }, 200);
        }

        obs.unobserve(e.target);
      });
    }, { threshold: 0.1 }).observe(footer);
  }

  /* ── 24. IMAGE CLIP-PATH REVEAL ──────────────────── */
  function setupImageClipReveal() {
    if (reduced || !('IntersectionObserver' in window)) return;

    var images = document.querySelectorAll(
      '.story-image img, .story-visual img, .gallery-item img, .lp-story__image img'
    );
    if (!images.length) return;

    images.forEach(function (img) {
      img.classList.add('clip-reveal');
    });

    var clipObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('revealed');
        clipObs.unobserve(e.target);
      });
    }, { threshold: 0.15 });

    images.forEach(function (img) { clipObs.observe(img); });
  }

  /* ── 25. SCROLL PROGRESS PULSE ───────────────────── */
  function setupProgressPulse() {
    if (reduced || !('IntersectionObserver' in window)) return;
    var sections = document.querySelectorAll('.animate-section');
    if (!sections.length) return;

    var pulseObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        bar.classList.add('pulse');
        setTimeout(function () {
          bar.classList.remove('pulse');
        }, 400);
      });
    }, { threshold: 0.3 });

    sections.forEach(function (s) { pulseObs.observe(s); });
  }

  /* ── 26. PRODUCT CARD 3D HOVER LIFT ──────────────── */
  function setupProductHoverLift() {
    if (reduced || isMobile) return;
    var cards = document.querySelectorAll('.product-card');
    cards.forEach(function (card) {
      card.classList.add('hover-lift-3d');
    });
  }

  /* ── 27. NEWSLETTER FORM INTERACTION ───────────────── */
  function setupNewsletterInteraction() {
    var form = document.querySelector('.newsletter-form');
    if (!form) return;

    var input = form.querySelector('.newsletter-input');
    var submit = form.querySelector('.newsletter-submit');

    if (input) {
      /* Enhanced focus state is handled by CSS */
      input.addEventListener('focus', function () {
        form.classList.add('focused');
      });
      input.addEventListener('blur', function () {
        form.classList.remove('focused');
      });
    }

    if (submit) {
      /* Store original text */
      var originalText = submit.textContent;

      form.addEventListener('submit', function () {
        /* Brief success animation */
        setTimeout(function () {
          submit.classList.add('success');
          submit.innerHTML = '<span class="checkmark">&#10003;</span> ' + originalText;
          setTimeout(function () {
            submit.classList.remove('success');
            submit.textContent = originalText;
          }, 2000);
        }, 300);
      });
    }
  }

  /* ── INIT ────────────────────────────────────────────── */
  function init() {
    setupParallax();
    setupTilt();
    setupStagger();
    setupSectionDepth();
    setupTitleReveal();
    setupParticles();
    setupShimmer();
    setupMagneticBtns();
    setupRipple();
    setupCounters();
    setupCustomCursor();
    setupTextHighlight();
    setupTestimonialEnhancements();
    setupNewsletterInteraction();

    /* New 3D & Scroll effects */
    setupHero3DScroll();
    setupDepthLayers();
    setupFloatingShapes();
    setupSectionParallax();
    setupOpacityFade();
    setupEventStagger();
    setupGalleryDrop();
    setupFooterReveal();
    setupImageClipReveal();
    setupProgressPulse();
    setupProductHoverLift();
  }

  /* Page load runs immediately, rest after DOM ready */
  setupPageLoad();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
